module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/vuex-photoprism-service-api/~/axios/index.js
// module id = 857
// module chunks = 0 3